"use strict";
function sequence(items, call) {
    return items.reduce(function (promise, t) {
        return promise.then(function () { return coerceToPromise(call(t)); });
    }, Promise.resolve());
}
exports.sequence = sequence;
function coerceToPromise(x) {
    return x && typeof x.subscribe === 'function'
        ? observableToPromise(x)
        : Promise.resolve(x);
}
function observableToPromise(x) {
    return new Promise(function (resolve, reject) {
        x.subscribe(createObserver(resolve, reject));
    });
}
function createObserver(resolve, reject) {
    return {
        next: Function.prototype,
        error: reject,
        complete: resolve,
    };
}
//# sourceMappingURL=index.js.map